import * as Yup from 'yup';

export const FilterFormSchema = Yup.object().shape({
    pipelineType: Yup.string(),
    pipelineStatus: Yup.string(),
    codeRepositoryName: Yup.string(),
});
